import { History } from "history";
import L10n from "localization";
import GoalSchoolNav from "./goalSchoolNav";
import SingleSelectNav, { IPromptOption } from "./singleSelectNav";

interface GradeLevelNavProps {
  dismiss: () => Promise<void>;
  onAddToInbox: () => void;
  history: History;
  logStep: (step: string, details?: object) => void;
}

const opts: IPromptOption[] = [
  {
    name: L10n.localize((s) => s.onboarding.gradeLevelPreCollegeName),
    val: "pre-college",
    desc: L10n.localize((s) => s.onboarding.gradeLevelPreCollegeDesc),
  },
  {
    name: L10n.localize((s) => s.onboarding.gradeLevelStartingCollegeName),
    val: "starting-college",
    desc: L10n.localize((s) => s.onboarding.gradeLevelStartingCollegeDesc),
  },
  {
    name: L10n.localize((s) => s.onboarding.gradeLevelInCollegeName),
    val: "in-college",
    desc: L10n.localize((s) => s.onboarding.gradeLevelInCollegeDesc),
  },
  {
    name: L10n.localize((s) => s.onboarding.gradeLevelPostCollegeName),
    val: "post-college",
    desc: L10n.localize((s) => s.onboarding.gradeLevelPostCollegeDesc),
  },
];

const GradeLevelNav: React.FC<GradeLevelNavProps> = (props) => {
  return (
    <SingleSelectNav
      title={L10n.localize((s) => s.onboarding.schoolNavTitle)}
      description={L10n.localize((s) => s.onboarding.gradeLevelNavDescription)}
      options={opts}
      dismiss={props.dismiss}
      history={props.history}
      onNav={(opt) => {
        props.logStep("picked_grade_level", { gradeLevel: opt.name });
        return (
          <GoalSchoolNav
            dismiss={props.dismiss}
            history={props.history}
            onAddToInbox={props.onAddToInbox}
            logStep={props.logStep}
            gradeLevel={opt.val}
          />
        );
      }}
    />
  );
};

export default GradeLevelNav;
